<div class="row">  
  <span class="col-md-12 text-right boldlbl">Page 3 of 10</span>  
</div>
<div class="row p-4">
    <div class="col-md-12">
        <h3 class="text-center">New Business Registration</h3>
        <h4 class="text-center">Questionnaire</h4>
    </div>
</div>
<div *ngIf="errorExist" id="alertRef" class="alert alert-danger fadein">
    <a href="#" class="close" data-dismiss="alert">&times;</a> <strong>Error!</strong>
    {{errorMessage}}
</div>
<div class="row">
    <div class="col-md-12 text-right">
        <label class="boldlbl"><span class="errorMsg">*</span>indicates required field.</label>
    </div>
</div>
<form [formGroup]="fForm" (ngSubmit)="submit()">
    <div class="card">
        <div class="card-body">
            <div class="table-condensed table-responsive">
                <table class="table table-borderless">
                    <!-- display new acct verification section  -->
                    <tbody [attr.id]="TRCQGroups[DupEntryGrpRow]?.metaName">
                        <tr>
                            <td colspan="4">
                                <strong>{{TRCQGroups[DupEntryGrpRow].questionGroup}}</strong>
                            </td>
                        </tr>
                        <tr *ngIf="TRCQGroups[DupEntryGrpRow]?.notes">
                            <td colspan="4">
                                {{TRCQGroups[DupEntryGrpRow].notes}}
                            </td>
                        </tr>
                        <jhi-dsp-questions-answers [qQuestions]="qQuestions"  [parentForm]="fForm" [DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqIndY" (answerAdded)="update($event)" style="display:contents">
                        </jhi-dsp-questions-answers>
                    </tbody>
                </table>
                <table  id="level1_table" class="table table-bordered">
                    <tbody [attr.id]="TRCQGroups[BusGrpRow]?.metaName">
                        <tr>
                            <td colspan="4">
                                <strong>{{TRCQGroups[BusGrpRow].questionGroup}}</strong>
                            </td>
                        </tr>
                        <!-- <tr *ngIf="TRCQGroups[BusGrpRow]?.notes && TRCQGroups[BusGrpRow].notes.length > 0"> -->
                        <tr *ngIf="TRCQGroups[BusGrpRow]?.notes">
                            <td colspan="4">
                                {{TRCQGroups[BusGrpRow].notes}}
                            </td>
                        </tr>
                        <jhi-dsp-questions-answers [qQuestions]="qQuestions1" [parentForm]="fForm" [DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqIndN" (click)="data()" (answerAdded)="update($event)" style="display:contents">
                        </jhi-dsp-questions-answers>
                        <!-- include eappreg_get_table here -->
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div>
        <br>
    </div>
    <div class="text-center">
        <input type="button" class="btn btn-primary" routerLink="/eappreg_criteria" value="Back"/>
        <button type="submit" class="btn btn-primary">Accept and Proceed</button>
    </div>
    <div>
        <br>
    </div>
</form>